/**
 * Cup component is an individual cup for the game. It can render in a variety
 * of locations based on its properties.
 */


import React from 'react';


class CupComponent extends React.Component {
  render() {

    // generate class string for component
    let classes = 'cup-component';
    let colorOfPosition = this.props.colorOfPosition || '#000';
    let displayPosition = this.props.displayPosition || false;
    const toggleTextShadow = this.props.toggleTextShadow || false;
    const textShadowColor = this.props.textShadowColor || "#000";
    classes += ' position-' + this.props.position;
    classes += this.props.isUp ? ' up' : ' down';
    const cupImage = this.props.shellImage || "assets/images/shell.png"

    return (
      <div className={classes}>
        <img src={cupImage} />
        {displayPosition &&
            <div className="row">
              <span style={{fontFamily: "Oswald", fontSize: 150, color: colorOfPosition, textShadow: toggleTextShadow ? `5px 5px ${textShadowColor}` : "none"}}>{this.props.position}</span>
            </div>
        }
      </div>
    );
  }
}

export default CupComponent;
